
import React, { FC, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';

import useGetIntialDate from '../../CustomHooks/useGetIntialDate';
import "./FilterTransaction.scss";


interface FilterTransactionProp {
    toggleFilterTRX: () => void;
}


const FilterTransaction: FC<FilterTransactionProp> = ({ toggleFilterTRX }) => {


    const { getIntialDate ,  toFormattedDate } = useGetIntialDate();
    const [trxtype , setTrxType]=useState("All") ; 
    const [filterTrxValues, setFilterTrxValues] = useState({ from: toFormattedDate, to: toFormattedDate, transactionNum: "", transactionType:trxtype, minAmount: "", maxAmount: "" });
    const { t } = useTranslation('translation', { keyPrefix:"userScreen.Filter" })
    const handleFilterChange = (e: any) => {
        setFilterTrxValues({ ...filterTrxValues, [e.target.name]: e.target.value })
    }
    const handletypeChange =( type : string )=>{
        setTrxType(type) ; 
        setFilterTrxValues({...filterTrxValues , transactionType:type })
    }

    //const typeEle= document.getElementsByClassName("trx-type")  as HTMLCollectionOf<HTMLElement>   ; 
    useLayoutEffect(() => {
        document.body.style.overflow = "hidden";
        getIntialDate() ; 
        return () => {
            document.body.style.overflow = "auto";
        }
    }, [])


    return (
        <div className='filterTrx-Container' style={{ height: `100%` }}>
            <div className='filter-popup'>
                <div className='filter-header'> <p className='header'> {t("filter")} </p> <p onClick={toggleFilterTRX}> <IoClose />  </p> </div>
                <div className='filter-box-container'>
                    <div className='filter-title'>
                        <p className='title'> {t("trxtype")}   </p>
                    </div>
                    <div className='filter-input'>
                        <div className='filter-element'>
                            <div className='check-type'> 
                                <span className={`trx-type ${trxtype==="All" && "activeType"}`} onClick={()=>{handletypeChange("All")}}> {t("all")} </span>
                                <span className={`trx-type ${trxtype==="Payment" && "activeType"}`} onClick={()=>{handletypeChange("Payment")}}> {t("payment")}  </span>
                                <span className={`trx-type ${trxtype==="Refund" && "activeType"}`} onClick={()=>{handletypeChange("Refund")}}> {t("refund")} </span>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='filter-box-container'>
                    <div className='filter-title'>
                        <p className='title'> {t("trxnumber")}   </p>
                    </div>
                    <div className='filter-input' >
                        <div className='filter-element'>
                            <input type="text" className='filterTrx-input' onChange={handleFilterChange} name='transactionNum' required />
                            <p className='input-title'> {t("trxnum")} </p>
                        </div>

                    </div>

                </div>
                <div className='filter-box-container'>
                    <div className='filter-title'>
                        <p className='title'> {t("trxdate")}  </p>
                    </div>
                    <div className='filter-input'>
                        <div className='filter-element'>
                            <input type="date" className='filterTrx-input date' name='from'  onChange={handleFilterChange} required />
                            <p className='input-title'> {t("from")} </p>
                        </div>
                        <div className='filter-element'>
                            <input type="date" className='filterTrx-input date' name='to'  onChange={handleFilterChange} required />
                            <p className='input-title' >{t("to")} </p>
                        </div>

                    </div>

                </div>
                <div className='filter-box-container'>
                    <div className='filter-title'>
                        <p className='title'> {t("trxAmount")}   </p>
                    </div>
                    <div className='filter-input'>
                        <div className='filter-element'>
                            <input type="text" name="minAmount" className='filterTrx-input' onChange={handleFilterChange} required />
                            <p className='input-title'> {t("min")} </p>
                        </div>
                        <div className='filter-element'>
                            <input type="text" name='maxAmount' className='filterTrx-input' onChange={handleFilterChange} required />
                            <p className='input-title'> {t("max")} </p>
                        </div>
                    </div>

                </div>
                <div className='filter-Buttons'>
                    <button className='filter-button' /* onClick={() => { console.log(filterTrxValues) }} */>
                    {t("Apply")}
                    </button>
                    {/* <button className='cancel-button' onClick={toggleFilterTRX}>
                        Cancel
                    </button> */}
                </div>

            </div>
        </div>
    )
}
export default FilterTransaction;

